import React from 'react';

import { di } from 'react-magnetic-di';

import { Inline, Stack } from '@atlaskit/primitives/compiled';
import Select from '@atlaskit/select/default';
import type { OptionType } from '@atlaskit/select/types';

import { asOptionsValue } from '../../../../../../../../common/types/form/form-fields/field-values/utils';
import { asFormOptionField } from '../../../../../../../../common/types/form/form-fields/utils';
import type { FormFieldComponentRendererProps } from '../../../../../../../../common/types/renderers';
import {
	findChildValue,
	findParentValue,
} from '../../../../../../../../common/utils/cascading-fields/utils';
import {
	useCurrentValue,
	useFormField,
} from '../../../../../../../../controllers/form-renderer-store';

export const PreviewCascadingSelectInput = ({
	fieldId,
	fieldInputId,
}: FormFieldComponentRendererProps): React.JSX.Element => {
	di(useFormField);

	const currentValue = asOptionsValue(useCurrentValue({ fieldId }));
	const formField = useFormField({ fieldId });
	const formOptionField = asFormOptionField(formField);

	if (formOptionField === undefined) {
		return <></>;
	}

	return (
		<Inline testId={`field-input-cascading-select-preview-${fieldId}`} space="space.100">
			<Stack grow="fill">
				<Select<OptionType>
					key={fieldInputId}
					inputId={fieldInputId}
					value={findParentValue(formOptionField, currentValue)}
					isDisabled
				/>
			</Stack>
			<Stack grow="fill">
				<Select<OptionType>
					key={`${fieldInputId}-child`}
					value={findChildValue(formOptionField, currentValue)}
					isDisabled
				/>
			</Stack>
		</Inline>
	);
};
